(() => {
  const selector = '.product-card-wrapper .card > .card__content > .card__information';
  const variable = '--pino-card-title-height';
  const observed = new WeakSet();
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const update = () => {
    scheduled = false;
    const cards = Array.from(document.querySelectorAll(selector)).map(info => {
      const heading = info.querySelector(':scope > .card__heading');
      const wrapper = info.closest('.product-card-wrapper');
      const list = wrapper && wrapper.closest('ul, .product-grid, .pino-designer-carousel__rail');
      if (!heading || !wrapper || !list) return null;
      const rail = list.closest('[data-products-viewport], .slider, .pino-designer-carousel__rail');
      const viewport = rail || list;
      if (!observed.has(viewport)) {
        observed.add(viewport);
        if (resizeObserver) resizeObserver.observe(viewport);
      }
      return { info, heading, wrapper, list, viewport, rail };
    }).filter(Boolean);
    cards.forEach(({ info }) => info.style.removeProperty(variable));
    const rows = [];
    cards.forEach(card => {
      const box = card.wrapper.getBoundingClientRect();
      const viewport = card.viewport.getBoundingClientRect();
      if (!box.width || !box.height || !card.wrapper.getClientRects().length) return;
      if (!card.rail && (box.right <= viewport.left || box.left >= viewport.right)) return;
      const top = box.top;
      let row = rows.find(item => item.list === card.list && Math.abs(item.top - top) < 3);
      if (!row) { row = { list: card.list, top, cards: [], height: 0 }; rows.push(row); }
      row.cards.push(card);
      row.height = Math.max(row.height, card.heading.getBoundingClientRect().height);
    });
    rows.forEach(row => {
      const height = `${Math.ceil(row.height * 100) / 100}px`;
      row.cards.forEach(({ info }) => info.style.setProperty(variable, height));
    });
  };
  new MutationObserver(records => {
    if (records.some(record => record.type !== 'attributes' || record.attributeName !== 'style')) schedule();
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', schedule, true);
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    document.fonts.addEventListener('loadingdone', schedule);
  }
  schedule();
})();
